import React,{useState, useRef} from 'react' 
import {GetCustomer} from './redux/CustomerOperations'
import {useDispatch} from 'react-redux'
import {setCustomerList} from '../searchShowCustomer/redux/CustomerListSlice'
import CustomerList from './components/CustomerList'
import {setCustomerDetail} from '../searchShowCustomer/redux/CustomerDetailSlice'
import {CustomerDetailClass} from '../searchShowCustomer/models/CustomerModels'

export default function FileSend(){
    const [previewLoading, setPreviewLoading] = useState(false)
    const [firmaUnvanChecked, setFirmaUnvanChecked] = useState(false)
    const [firmaUnvanType, setFirmaUnvanType] = useState("");
    const [radioValue, setRadioValue] = useState("");
    const [currentInputType, setCurrentInputType] = useState("");
    const [errorString, setErrorString] = useState("");
    const [inputValue, setInputValue] = useState();
    const currentRef = useRef(null);
    const uploadButtonRef = useRef(null);
    console.log(currentRef);

    const dispatch = useDispatch();

	const handleSubmission = async () => {
    dispatch(setCustomerDetail(new CustomerDetailClass()));
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    setPreviewLoading(true);
    setErrorString("");
    console.log("input =>",inputValue);

        if(radioValue == "" || radioValue == null){
            setErrorString("Lütfen arama yapılacak alanı seçeniz.");
            setPreviewLoading(false);
            return;
       }
       else if(inputValue == "" || inputValue == null){
            setErrorString("Lütfen arama için bir parametre giriniz");
            setPreviewLoading(false);
            return;
       }
       else if(radioValue =="mail" && !pattern.test(inputValue)){
            setErrorString("Lütfen uygun bir mail formatı giriniz");
            setPreviewLoading(false);
            return;
       }
       console.log("input value =>",inputValue);
       
       if(inputValue != null){
        let customer = await CreateCustomerModel();
        console.log("Customer =>",customer);
        let resp =  await GetCustomer(customer, firmaUnvanType);
        console.log("Response =>",resp);
        if(resp.data != null){
            if (resp.data.Status != "SUCCESS"){
                setErrorString(resp.data.Detail);
            }else{
                dispatch(setCustomerList(resp.data.Detail));
            }
        }
        else{
            setErrorString("Servisten yanıt alınamadı");
        }       
        
       }
       setPreviewLoading(false);
	};

    const CreateObject = () => {
        function F() {}
        var customer = {
            CustomerNumber : 0,
            TaxNumber : 0,
            CardNumber : 0,
            MobilePhoneNumber : 0,
            PhoneNumber : 0,
            Email : '',
            ShortName : '',
            BrandName :''
        }
        F.prototype = customer;
        return new F();
    }

    const CreateCustomerModel = () => {
        var customer = CreateObject();
        switch(radioValue){
            case "mNo":
                customer.CustomerNumber = inputValue;
                break;
            case "vNo": 
                customer.TaxNumber = inputValue;
                break;
            case "kNo": 
                customer.CardNumber = inputValue;
                break;
            case "cep": 
                customer.MobilePhoneNumber = inputValue;
                break;
            case "phone":                 
                customer.PhoneNumber = inputValue;
                break; 
            case "mail":
                customer.Email = inputValue;
                break;
            case "sName":
                customer.ShortName = inputValue;
                break;
            case "fUnvan":
                customer.BrandName = inputValue;
                break;
        }
        return customer;
    }
 


	const handleChangeFunvan = e => {
        const {name, value} = e.target;
        setErrorString("");
        setFirmaUnvanType(value);
    }


	const handleChange = e => {
       const {name, value} = e.target;
       setErrorString("");
       setFirmaUnvanType("");
       setFirmaUnvanChecked(false);
       if(value == "fUnvan"){
        setFirmaUnvanChecked(true); 
       }
      //setInputValue(null);
       switch(value){
           case "mNo":
           case "vNo": 
           case "kNo": 
           case "cep": 
           case "phone": 
                setCurrentInputType("number");
                setInputValue("");
                break;
            case "mail":
                setCurrentInputType("email");
                setInputValue("");
                break;
            default:
                setCurrentInputType("text");
                setInputValue("");
              break;
       }
       setRadioValue(value);
       console.log(e);
	};
   

    return(
     <div className='col-xxl-12' style={{marginBottom:15}}>
        <div className={`card card-xxl-stretch`} style={{height:'auto'}}>
                {/* begin::Header */}
            <div className='card-header align-items-center border-0 mt-4' style={{display:'block',overflow:'scroll'}}>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='fw-bolder mb-2 text-dark'>Sorgulama/Doğrulama Ekranı</span>
                    <span className='text-muted fw-bold fs-7'>Lütfen hangi alana göre arama yapacağınızı seçiniz</span>
                </h3>
                <div className='card-toolbar'>
                {/* end::Header */}
                {/* begin::Body */}
                
                    <div className='card-body pt-5' style={{paddingLeft:0,marginBottom:15}}>
                        {/* <input type="file" name="file" onChange={changeHandler} /> */}
                        <div className="row gy-5 g-xl-8"> 
                         {errorString != "" && errorString != null &&  <div className="col-xxl-12">
                                <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                                    <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                                        <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                                <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                                <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                            </svg>
                                        </span>
                                    </span>
                                    <div className="d-flex flex-column">
                                        <h5 className="mb-1">Dikkat</h5>
                                        <span>{errorString}</span>
                                    </div>
                                </div>
                        </div>}
                        <div className="col-xxl-4">
                            <div className="row">
                                
                                            <div className="form-check form-check-custom form-check-solid" >
                                                <input className="form-check-input" id="rd1" type="radio" name="searchRadio" value="cep" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd1">Cep Telefonu</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid mb-3 mt-3">
                                                <input className="form-check-input" id="rd2" type="radio" name="searchRadio"  value="mNo" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd2">Müşteri No</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input className="form-check-input" id="rd3" type="radio" name="searchRadio"   value="vNo"  onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd3">Vergi No</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid  mb-3 mt-3">
                                                <input className="form-check-input" id="rd4" type="radio" name="searchRadio" value="kNo" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd4">Kart No</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input className="form-check-input" id="rd5" type="radio" name="searchRadio" value="mail" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd5">E-posta</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid  mb-3 mt-3">
                                                <input className="form-check-input" id="rd6" type="radio" name="searchRadio" value="fUnvan" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd6">Firma Ünvanı</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid">
                                                <input className="form-check-input" id="rd7" type="radio" name="searchRadio" value="phone" onChange={handleChange}/>
                                                <label className="form-check-label" htmlFor="rd7">Sabit Telefon</label>
                                            </div>
                                            <div className="form-check form-check-custom form-check-solid  mb-3 mt-3">
                                                <input className="form-check-input" id="rd8" type="radio" name="searchRadio" value="sName" onChange={handleChange}/>
                                                <label className="form-check-label"  htmlFor="rd8" >Satın Alma Yetkilisi Adı Soyadı</label>
                                            </div> 
                            </div>
                        </div>
                        <div className="col-xxl-6" style={{position:'relative'}}>
                                <div className="row" style={{position:'absolute',top:'32%',width:'100%'}}>
                                    <div className="col-xxl-6">
                                        <div className="row" style={{display:firmaUnvanChecked ? 'block' : 'none'}}>
                                            <div className="form-check form-check-custom form-check-solid  mb-3 mt-3">
                                                <div style={{marginLeft:'3%'}}>
                                                    <input className="form-check-input" id="bre" type="radio" name="searchRadioB" value="bireysel" onChange={handleChangeFunvan}/>
                                                    <label className="form-check-label"  htmlFor="bre" >Bireysel</label>
                                                </div>
                                                 <div style={{marginLeft:'8%'}}>
                                                    <input className="form-check-input" id="kru" type="radio" name="searchRadioB" value="kurumsal" onChange={handleChangeFunvan}/>
                                                    <label className="form-check-label"  htmlFor="kru" >Kurumsal</label>
                                                </div>
                                            </div> 
                                        </div>

                                        <input value={inputValue} onChange={e => setInputValue(e.target.value)} type={currentInputType} className="form-control form-control-solid" placeholder=""/>
                                    </div>
                                    <div className="col-xxl-6 position-relative">
                                        <button className="btn btn-primary" onClick={handleSubmission} disabled={previewLoading} ref={uploadButtonRef} style={{fontWeight:'normal',position:'absolute',bottom:0}}>
                                                <svg style={{ marginRight:3,width: 13,marginBottom:1}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                </svg>
                                                {!previewLoading && <span className='indicator-label'>Ara</span>}
                                                {previewLoading && (
                                                    <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                    Yükleniyor...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )} 
                                        </button>
                                    </div>
                                </div>
                        </div>
                        
                        <div className="col-xxl-12">
                             <CustomerList></CustomerList>
                        </div>
                        </div>
                    </div> 
                </div>
                {/* end: Card Body */}
            </div>
      </div>
      </div>
    )
}